import axios from 'axios';
import { isLoggedIn } from '../auth';

export function getQuizzes() {
	if (isLoggedIn()) {
		return axios.get('/v1/quiz');
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

export function getQuestions(id) {
	if (isLoggedIn()) {
		return axios.get(`v1/quiz/${id}/questions`);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

export function submitTestQuiz(data) {
	if (isLoggedIn()) {
		return axios.post('/v1/quizresponses', data);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

export function getTestOutcomes() {
	if (isLoggedIn()) {
		return axios.get('/v1/quizresponseoutcomes');
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

export function getUserTestOutcome(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/users/${id}/quiz`);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
 * Fetches course quizzes scores taken by user 
 * @param {Number} id - id of user
 * @returns {Promise} a promise of the course quiz scores to be resolved.
 */
export function getUserTestScores(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/scores/${id}/user`);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
 * Fetches pyschometric scores of tests taken by user 
 * @param {Number} id - id of user
 * @returns {Promise} - a promise of the pychometric tests to be resolved
 */
export function getUserPsychResponse(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/quizresponses/${id}/user`);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
 * Submits quiz scores 
 * @param {Object} data - object of answer response to be submitted
 * @returns {Promise} - a promise of the pychometric tests to be resolved
 */
export function submitScores(data) {
	if (isLoggedIn()) {
		return axios.post('/v1/scores', data);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
 * Fetches course module scores 
 * @param {Number} id - id of user
 * @returns {Promise} - a promise of the pychometric tests to be resolved
 */
export function getModuleQuiz() {
	if (isLoggedIn()) {
		return axios.get('/v1/classmodulequizzes');
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
 * Fetches course module scores 
 * @param {Number} id - id of user
 * @returns {Promise} - a promise of the pychometric tests to be resolved
 */
export function submitModuleQuiz(id, data) {
	if (isLoggedIn()) {
		return axios.post(`/v1/classmodulequizzes/${id}`, data);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}
